/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleretrohint4Inputs */

const en_aiflowstyleretrohint4 = /** @type {(inputs: Aiflowstyleretrohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`70s and 80s`)
};

const de_aiflowstyleretrohint4 = /** @type {(inputs: Aiflowstyleretrohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`70er und 80er`)
};

/**
* | output |
* | --- |
* | "70s and 80s" |
*
* @param {Aiflowstyleretrohint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleretrohint4 = /** @type {((inputs?: Aiflowstyleretrohint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleretrohint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleretrohint4(inputs)
	return de_aiflowstyleretrohint4(inputs)
});
export { aiflowstyleretrohint4 as "aiFlowStyleRetroHint" }